import { Tooltip } from "@xola/ui-kit";
import { capitalize } from "lodash";
import React from "react";
import { PaymentMethod } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { getPaymentMethodName } from "../../../models/Payment";
import { Currency } from "../../Common/Currency";
import { PaymentMethodIcon } from "../../Common/PaymentMethodIcon";

interface EarningsReportMethodProps {
    method: PaymentMethod;
    meta?: {
        paid: number;
        commission: number;
    };
    total: number;
}

const PaymentMethodPopover = ({ method, total, meta }: EarningsReportMethodProps) => {
    if (method !== PaymentMethod.CREDIT_CARD || !meta) {
        return null;
    }

    return (
        <div className="popover-breakdown flex w-44 flex-col space-y-1 p-0 text-sm">
            <div className="flex w-full justify-between">
                <span>Paid</span>
                <Currency>{meta.paid}</Currency>
            </div>
            <div className="flex w-full justify-between">
                <span>Processing Fees</span>
                <span>
                    <Currency>{meta.commission}</Currency>
                </span>
            </div>
            <hr />
            <div className="flex w-full justify-between">
                <span className="font-bold">Earning</span>
                <span>
                    <Currency>{total}</Currency>
                </span>
            </div>
        </div>
    );
};

export const EarningsReportMethod = ({ method, total, meta }: EarningsReportMethodProps) => {
    const seller = useSeller();

    return (
        <Tooltip
            allowHTML
            content={<PaymentMethodPopover method={method} meta={meta} total={total} />}
            disabled={!meta || method !== PaymentMethod.CREDIT_CARD}
        >
            <div className="mr-12 mt-2 flex w-25 flex-col items-center  space-y-2 " data-testid="earning-report-method">
                <div className="flex flex-row items-center space-x-1 whitespace-nowrap">
                    <PaymentMethodIcon method={method} />
                    <div className="text-sm">{getPaymentMethodName(seller, method) ?? capitalize(method)}</div>
                </div>

                <div className="whitespace-nowrap text-lg font-bold" data-testid="earning-report-method-total">
                    <Currency.Split currency={seller.currency}>{total}</Currency.Split>
                </div>
            </div>
        </Tooltip>
    );
};
